import { Grid, GridSize } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { UseAutocompleteProps } from "@material-ui/lab";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { FocusEventHandler } from "react";

interface CustomAutocompleteProps<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined
> extends UseAutocompleteProps<T, Multiple, DisableClearable, FreeSolo> {
  xs?: GridSize;
  sm?: GridSize;
  md?: GridSize;
  lg?: GridSize;
  xl?: GridSize;
  label: string;
  name?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  onBlur?: FocusEventHandler;
  disabled?: boolean;
}

export const CustomAutocomplete = <
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined
>(
  props: CustomAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>
) => {
  const { xs, sm, md, lg, xl, label, name, required, error, helperText, onBlur, ...autoCompleteProps } = props;

  return (
    <Grid item={true} xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
      <Autocomplete
        {...autoCompleteProps}
        onBlur={onBlur}
        renderInput={(params) => (
          <TextField {...params} label={label} name={name} required={required} error={error} helperText={helperText} />
        )}
      />
    </Grid>
  );
};
